import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@/redux/store';
import { App } from '@/app/App';
import '@/styles/theme.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('No #root element — index.html is not the one this app expects.');
}

createRoot(container).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
);
